import Repository from "./Repository";
import Assignment from "../types/Assignment";
import BaseResponse from "../types/BaseResponse";
import TeamAssignment from "../types/TeamAssignment";
import { Training } from "../types/Training";
import AssignRequest from "../types/AssignRequest";
import Axios from "axios";

const resource = "/assignment";

export default {
  get(assignmentId: string) {
    return Repository.get(`${resource}/${assignmentId}/topics`);
  },
  getForEmployeeId(employeeId: string) {
    return Repository.get(`${resource}/employee/${employeeId}`);
  },
  save(assignment: Assignment) {
    if (assignment.assignmentId) {
      return Repository.patch(
        `${resource}/${assignment.assignmentId}`,
        assignment
      );
    } else {
      return Repository.post(`${resource}`, assignment);
    }
  },
  assignToGroup(assignment: Assignment) {
    return Repository.post(`${resource}/employeeGroup`, assignment);
  },
  complete(assignmentId: string) {
    return Repository.patch(`${resource}/${assignmentId}/complete`);
  },
  getTeam(employeeId: string) {
    return Repository.get<BaseResponse<TeamAssignment[]>>(
      `${resource}/employee/${employeeId}/team`
    );
  },
  getCompany(companyId: string) {
    return Repository.get<BaseResponse<TeamAssignment[]>>(
      `${resource}/company/${companyId}`
    );
  },
  getByGroup(groupId: string) {
    return Repository.get<BaseResponse<Training[]>>(
      `${resource}/employeeGroup/${groupId}`
    );
  },
  assign(request: AssignRequest) {
    return Repository.post(`${resource}/assign/`, request);
  },
  override(assignmentIds: string[], dueDate: string, doNotRepeat: boolean) {
    return Axios.all(
      assignmentIds.map((id) =>
        Repository.post(
          `${resource}/${id}/dueDate/${dueDate}/${doNotRepeat ? "true" : "false"
          }`
        )
      )
    );
  },
  delete(assignmentId: string) {
    return Repository.delete(`${resource}/${assignmentId}`);
  },
  deleteAll(companyId: string, assignmentIds: string[], forceDeletion: boolean) {
    return Repository.delete(`${resource}/deleteList`, {
      data: {
        companyId,
        assignmentIds,
        forceDeletion
      },
    });
  },
  deleteGroups(
    companyId: string,
    employeeGroupIds: string[],
    trainingId: string
  ) {
    return Repository.delete(`${resource}/delete/employeeGroups`, {
      data: {
        companyId,
        employeeGroupIds,
        trainingId,
      },
    });
  },
  getGroupAssignments(
    employeeGroupId: string,
    trainingId: string
  ) {
    return Repository.get(`${resource}/group/${employeeGroupId}/${trainingId}/assignments`, {
    });
  },
  deleteTrainingFromEmployeeGroup(
    employeeGroupId: string,
    trainingId: string
  ) {
    return Repository.delete(`${resource}/group/delete/${employeeGroupId}/${trainingId}`, {
    });
  },
  deleteGroupDocuments(
    companyId: string,
    employeeGroupId: string,
    documentIds: string[]
  ) {
    return Repository.delete(`${resource}/delete/documents/employeeGroups`, {
      data: {
        companyId,
        employeeGroupId,
        documentIds,
      },
    });
  },
};
